import React from "react";
import { Link } from "react-router-dom";
import button from '../img/button.png';

const ROLES = [
  "Product design",
  "Full-stack development",
  "Art",
  "Project leadership",
  "AI Product Development",
  "Photography",
];

function AboutBear({ img }) {
  return (
    <section className="pb-intro" style={{ backgroundImage: `url(${img})` }}>
      <div className="pb-intro-veil" />

      <div className="pb-intro-copy">
        <div className="pb-label">
          <span className="pb-label-num">01</span>
          <span className="pb-label-rule" />
          <span className="pb-label-text">Introduction</span>
        </div>

        <h2 className="pb-heading">Hi, I'm Andy.</h2>

        <p>I've spent the last 15 years making things, and I still get excited every time something I helped build comes to life. I started out as a designer, taught myself to build what I designed as a full-stack developer, and these days I lead product, bringing designers, engineers, and business folks together to ship things people actually love to use.</p>
        <p>I've lived and breathed the startup life and climbed the corporate ladder, and both taught me the same thing: simplicity is an art form. The best products don't feel complicated, even when what's behind them is. That's what I chase in everything I do, whether it's a big platform, a small app, or a side project I can't stop thinking about at 2am.</p>
        <p>Lately that's meant building with AI, designing in Figma and turning ideas into working products faster than ever. I love to dig into a problem, find what's really going on, and come up with something simple, useful, and good looking.</p>
        <p>Outside of work I have a deep passion for the visual arts, photography, and self expression. Honestly though, I just wanna have a good time. When I'm not creating, you'll find me playing my favorite video game, watching Star Trek reruns, or getting lost in the mountains with my overlanding crew.</p>

        <ul className="pb-roles">
          {ROLES.map((role) => <li key={role}>{role}</li>)}
        </ul>

        <Link to="/resume" className="pb-button" style={{ backgroundImage: `url(${button})` }}>
          Resume
        </Link>
      </div>
    </section>
  );
}

export default AboutBear;
